module.exports = __webpack_public_path__ + "static/media/exchange-01.80c4b37b.webm";